export default "__VITE_ASSET__22e9912b__"